import { getApiBaseUrl } from '../config/apiBase';

const documentApiUrl = process.env.REACT_APP_DATAROOM_API_URL || `${getApiBaseUrl()}/dataroom-proxy`;

export default documentApiUrl;